import { render } from "./TdAbout.vue?vue&type=template&id=5ca7b62a&scoped=true"
import script from "./TdAbout.vue?vue&type=script&lang=js"
export * from "./TdAbout.vue?vue&type=script&lang=js"

import "./TdAbout.vue?vue&type=style&index=0&id=5ca7b62a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca7b62a"]])

export default __exports__